<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="syllai-logo-symbol-gradient"
        x1="6"
        y1="6"
        x2="58"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#6D4AFF" />
        <stop offset="0.55" stop-color="#3B82F6" />
        <stop offset="1" stop-color="#22D3EE" />
      </linearGradient>
    </defs>
    <g fill="url(#syllai-logo-symbol-gradient)">
      <rect x="6" y="6" width="52" height="46" rx="16" />
      <path d="M15 38 L10.5 60 L32 49 Z" />
    </g>
    <path
      d="M32 14.5 C33.6 24.2 36.8 27.4 46.5 29 C36.8 30.6 33.6 33.8 32 43.5 C30.4 33.8 27.2 30.6 17.5 29 C27.2 27.4 30.4 24.2 32 14.5 Z"
      fill="white"
    />
    <path
      d="M45.5 10.5 C46.1 14 47 14.9 50.5 15.5 C47 16.1 46.1 17 45.5 20.5 C44.9 17 44 16.1 40.5 15.5 C44 14.9 44.9 14 45.5 10.5 Z"
      fill="white"
      opacity="0.9"
    />
  </svg>
</template>
